import {NavigationDropdown} from '../components'

const taxonomy = {
	organisations: {to: '/firms/organisations'},
	environments: {to: '/firms/environments'},
	users: {
		items: {
			search: {to: '/search/user'},
			import_users: {modalLink: '/users/import'},
			export_to_excel: {modalLink: '/users/export'},
		},
	},
}

export const Firms = () => <NavigationDropdown name="firms" taxonomy={taxonomy} />
